/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Registry_PrivateInputs */

const es_ab_registry_private = /** @type {(inputs: Ab_Registry_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`privado`)
};

const gl_ab_registry_private = /** @type {(inputs: Ab_Registry_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`privado`)
};

const en_ab_registry_private = /** @type {(inputs: Ab_Registry_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`private`)
};

/**
* | output |
* | --- |
* | "private" |
*
* @param {Ab_Registry_PrivateInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_registry_private = /** @type {((inputs?: Ab_Registry_PrivateInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Registry_PrivateInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_registry_private(inputs)
	if (locale === "en") return en_ab_registry_private(inputs)
	return es_ab_registry_private(inputs)
});